module.exports = __webpack_public_path__ + "static/media/Main_logo.ef0d6680.svg";